import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import styled from "styled-components";

import MultiplyDivide from "../../applications/MultiplyDivide/Rating.js";
import Spelling from "../../applications/Spelling/Rating.js";
import Addition from "../../applications/Addition/Rating.js";
import Fractions from "../../applications/Fractions/Rating.js";
import Grammar from "../../applications/Grammar/Rating.js";
import Geometry from "../../applications/Geometry/Rating.js";
import Measurements from "../../applications/Measurements/Rating.js";
import PlaceValue from "../../applications/NumPlace/Rating.js";
import Statistics from "../../applications/Statistics/Rating.js";
import Numerals from "../../applications/Numerals/Rating.js";
import Algebra from "../../applications/Algebra/Rating.js"
import MTC from "../../applications/MTC/Rating.js"
import NumeracyIntervention from "../../applications/NumeracyIntervention/Rating.js";
import Phonics from "../../applications/Phonics/Rating.js"
import NumberSense from "../../applications/NumberSense/Rating.js"
import Ratios from "../../applications/Ratios/Rating.js"
import MathsVocab from "../../applications/MathsVocab/Rating.js";

import SPATS from "../Show/SpellingSATsPractice.js";
import KS1 from "../Show/KS1Practice.js";

export default function Rating({ id, ...props }) {
  const game = useGame(id);
  const [gameStatus, setGameStatus] = useState(true);

  function HardCodedSPATS(){
    var tops = [];
    for (let i = 1; i < 7; i++) {
      var obj = {'name': "Year " + i, 'value': i };
      tops.push(obj);
    }
    return tops;
  }

  function HardCodedKS1(){
    var tops = [];
    for (let i = 1; i < 6; i++) {
      var obj = {'name': "Round " + i, 'value': i };
      tops.push(obj);
    }
    return tops;
  }

  const gameComponent = () => {
    switch (game.service_key) {
      case "timetables":
        return (
          <MultiplyDivide 
          onBack={() => setGameStatus(false)} 
          game={game} 
          gameType={game.game_type}
          />
        );
      case "spelling":
        return (
          <Spelling
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
          />
        );
        case "addition":
          return(
            <Addition
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
          case "fractions":
          return(
            <Fractions
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
          case "grammar":
          return(
            <Grammar
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
          case "geometry":
          return(
            <Geometry
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
          case "measurement":
          return(
            <Measurements
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
          case "numplace":
          return(
            <PlaceValue
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
          case "statistics":
          return(
            <Statistics
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
          case "romannumerals":
          return(
            <Numerals
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            />
          )
        case "MTC":
          return (
            <MTC
              onBack={() => setGameStatus(false)}
              game={game}
              gameType={game.game_type}
            />
          );
          case "algebra":
            return (
              <Algebra
                onBack={() => setGameStatus(false)}
                game={game}
                gameType={game.game_type}
              />
            );
            case "assessnumeracy":
              return (
                <NumeracyIntervention
                  onBack={() => setGameStatus(false)}
                  game={game}
                  gameType={game.game_type}
                />
              );
              case "phonics":
                return (
                  <Phonics
                    onBack={() => setGameStatus(false)}
                    game={game}
                    gameType={game.game_type}
                  />
                );
                case "numbersense":
                  return (
                    <NumberSense
                      onBack={() => setGameStatus(false)}
                      game={game}
                      gameType={game.game_type}
                    />
                  );
                  case "ratioprop":
                    return (
                      <Ratios
                        onBack={() => setGameStatus(false)}
                        game={game}
                        gameType={game.game_type}
                      />
                    );
                    case "mvocab":
                      return (
                        <MathsVocab
                          onBack={() => setGameStatus(false)}
                          game={game}
                          gameType={game.game_type}
                        />
                      );
                      case "spellingsats":
                        return(
                          <SPATS
                            ratingmode={true}
                            />
                        );
                        case "keystage1arithmetic":
                        return(
                          <KS1
                            ratingmode={true}
                            />
                        );
                        
      default:
        return null;
    }
  };

  return <div>{gameComponent()}</div>;
}

//  <SPATS topics={selectedTopics}timer={customTimer}access={accessability}></SPATS>
